import React, { useContext, createContext, useState } from 'react';
import { PropTypes } from 'prop-types';

const initialState = {
  isOpen: false,
  pat_name: 'Não Encontrado',
};

const RenewConsentModalContext = createContext(initialState);

export function RenewConsentModalContextProvider({ children }) {
  const [renewConsentModalState, setRenewConsentModalState] =
    useState(initialState);

  return (
    <RenewConsentModalContext.Provider
      value={{ renewConsentModalState, setRenewConsentModalState }}
    >
      {children}
    </RenewConsentModalContext.Provider>
  );
}

export function useRenewConsentModalContext() {
  return useContext(RenewConsentModalContext);
}

RenewConsentModalContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};
